export default __webpack_public_path__ + "static/media/filterDark.77ce6516.svg";